import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';
import { sumBy } from 'lodash';
import { username } from '../helpers';
import { t } from '../../../../modules/infra/i18n';

const AdminCustomerDuplicatesList = ({ duplicates, setDuplicate }) => (
  <ReactTable
    data={duplicates}
    showPagination={false}
    defaultPageSize={10000}
    minRows={0}
    noDataText={t('admin:customers.duplicates_list.no_data_text')}
    className="ReactTable ReactTable--row-spacing-only u-mt+"
    columns={[
      {
        Header: t('admin:customers.duplicates_list.first_name_header'),
        accessor: 'firstName',
      },
      {
        Header: t('admin:customers.duplicates_list.last_name_header'),
        accessor: 'lastName',
      },
      {
        Header: t('admin:customers.duplicates_list.email_header'),
        accessor: 'email',
      },
      {
        Header: t('admin:customers.duplicates_list.phone_header'),
        accessor: 'phone',
      },
      {
        Header: t('admin:customers.duplicates_list.username_header'),
        id: 'username',
        accessor: c => username(c),
      },
      {
        Header: t('admin:customers.duplicates_list.shops_header'),
        id: 'shops_count',
        accessor: c => c.shops.length,
      },
      {
        Header: t('admin:customers.duplicates_list.appts_count_header'),
        id: 'appts_count',
        accessor: c => sumBy(c.shops, shop => shop.appointments.length),
      },
      {
        Header: t('admin:customers.duplicates_list.actions_header'),
        id: 'actions',
        accessor: c => c,
        Cell: props => (
          <button type="button" className="c-btn c-btn--small" onClick={() => setDuplicate(props.value)}>
            {t('admin:customers.duplicates_list.compare_button')}
          </button>
        ),
      },
    ]}
  />
);

AdminCustomerDuplicatesList.propTypes = {
  setDuplicate: PropTypes.func.isRequired,
  duplicates: PropTypes.array.isRequired,
};

export default AdminCustomerDuplicatesList;
